import api from './api.service'

export default {
  requestAccess(data) {
    return api.store('notifications/request-access', data)
  },
}
